import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthenticationGuard} from '@app/core/authentication/authentication.guard';
import {extract} from '@app/core/i18n.service';
import { Shell } from '@app/shell/shell.service';
import {UserDashboardComponent} from "./user-dashboard/user-dashboard.component";
import {UserDetailComponent} from "./user-detail/user-detail.component";
import {UserRewardComponent} from "./user-reward/user-reward.component";
import {UserSurveyComponent} from "@pages/user/user-survey/user-survey.component";
import {PopupCloseGuard} from "@shared/guard/popup-close.guard";


const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'home',
      data: { roles : ['admin', 'staff', 'user'], title: extract('Sondaggi') },
      component: UserDashboardComponent,
      canActivate: [AuthenticationGuard],
    },
    { path: 'reward/:mode',
      data: { roles : ['user'],  title: extract('Premi'), mode: 'reward' },
      component: UserRewardComponent,
      canDeactivate: [PopupCloseGuard],
      canActivate: [AuthenticationGuard],
    },
    { path: ':id/reward',
      data: { roles : ['user'],  title: extract('Premi - Dettaglio') },
      component: UserRewardComponent,
      canActivate: [AuthenticationGuard],
    },
    { path: 'detail',
      data: { roles : ['user'],  title: extract('I tuoi dettagli') },
      component: UserDetailComponent,
      canActivate: [AuthenticationGuard],
    },
    { path: ':id/detail',
      data: { roles : ['admin', 'staff'],  title: extract('I tuoi dettagli') },
      component: UserDetailComponent,
      canActivate: [AuthenticationGuard],
    },
    { path: ':id',
      data: { roles : ['admin', 'staff', 'user'],  title: extract('Participant') },
      component: UserDashboardComponent,
      canActivate: [AuthenticationGuard],
    },
    { path: 'survey/:id',
      data: { roles : ['admin', 'staff', 'user'],  title: extract('Sondaggio') },
      component: UserSurveyComponent,
      canActivate: [AuthenticationGuard],
    },
    { path: '**', redirectTo: 'home', pathMatch: 'full' },
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class UserPagesRoutingModule { }
